export default "/static/baton/app/dist/b128f9e98de1bbea51b7e650e6a6e3c7.ttf";